<div style="margin-top: 100px;" class="h-100 d-flex flex-column justify-content-center align-items-center">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
    <div style="margin-top: 40%;" class="mt-2">Please Wait...</div>
</div>
